// sesionesService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'sesiones/';

export interface Sesion {
    id: number;
    cita: number | { id: number };
    archivada?: boolean;
    fecha_inicio: string;
    fecha_fin: string;
    hora_inicio: string;
    hora_fin: string | null;
    horas: number;
    fin_semana: string;
    precio?: number;
    precio_temporizador?: number | null;  // ✅ NUEVO
    precio_con_descuento?: number;
    precio_activo?: number | null;         // ✅ NUEVO (opcional)
    estado_pago?: string;
    monto_pagado?: number;
    saldo_pendiente?: number;
    horas_asignadas?: number;
    tiene_horas_regalo?: boolean;
    horas_regalo_disponibles?: number;
    horas_regalo_estado?: 'sin_beneficio' | 'por_comenzar' | 'vigente' | 'agotado' | 'vencido';
}

// GET: Obtener todas las sesiones
export const fetchSesiones = async (): Promise<Sesion[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Sesion[]>(API_URL);
        return response.data;
    });
};

// POST: Crear una nueva sesión
export const createSesion = async (data: {
    cita: number;
    fecha_inicio: string;
    fecha_fin: string;
    hora_inicio: string;
    hora_fin: string;
    horas: number;
    fin_semana: string;
    precio: number;
    precio_temporizador?: number | null;  // ✅ NUEVO
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar una sesión existente
export const updateSesion = async (
    id: number,
    data: {
        cita: number;
        fecha_inicio: string;
        fecha_fin: string;
        hora_inicio: string;
        hora_fin: string;
        horas: number;
        fin_semana: string;
        precio: number;
        precio_temporizador?: number | null;  // ✅ NUEVO
    }
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar una sesión
export const deleteSesion = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};

// GET: Obtener sesiones por cita
export const fetchSesionesByCita = async (citaId: number): Promise<Sesion[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Sesion[]>(`${API_URL}?cita=${citaId}`);
        const sesionesOrdenadas = response.data.sort((a, b) => a.id - b.id);
        return sesionesOrdenadas;
    });
};

